// extracted by mini-css-extract-plugin
export var border = "_1j-7";
export var brand = "_1j-r";
export var button = "_1j-j";
export var center = "_1j-9";
export var centered = "_1j-5";
export var closeButton = "_1j-b";
export var disabledWrapper = "_1j-k";
export var error = "_1j-n";
export var extraLarge = "_1j-4";
export var extraSmall = "_1j-1";
export var fill = "_1j-g";
export var footer = "_1j-f";
export var footerAction = "_1j-h";
export var footerButtons = "_1j-i";
export var header = "_1j-6";
export var icon = "_1j-m";
export var info = "_1j-q";
export var inline = "_1j-8";
export var large = "_1j-3";
export var main = "_1j-c";
export var modal = "_1j-0";
export var neutral = "_1j-s";
export var noPadding = "_1j-e";
export var none = "_1j-t";
export var scrollable = "_1j-d";
export var small = "_1j-2";
export var success = "_1j-p";
export var tight = "_1j-l";
export var titleIcon = "_1j-a";
export var warn = "_1j-o";